import cycleSo from "stores/cycle"
import { TASK_SCOPE, Task } from "types/Task"
import { DateRange, Uuid } from "types/global"
import { dateWithoutTime, haveValueDateRange, betweenDateRange } from "utils"
export * from "./edit"
export * from "./group"
export * from "./status"


/** restituisce i task filtrati secondo parametri */
export function getTaskFiltered(tasks: Task[], growUnitId: number = 0, scope?: TASK_SCOPE | string, group?: string, cycleUuid?: Uuid, range?: DateRange, text?: string): Task[] {
	if (!tasks) return []
	const haveRange = haveValueDateRange(range)
	const txt = text?.trim().toLowerCase() ?? ""

	// se non esiste il cycle allora ignora per il filtro
	if (!cycleSo.getCycleByUuid(cycleUuid)) cycleUuid = null

	const tasksFiltered = tasks.filter(task => {
		if (haveRange && !betweenDateRange(dateWithoutTime(task.dueDate), range)) return false
		if (growUnitId && task.growUnitId != growUnitId) return false
		if (scope && task.scope != scope) return false
		if (group && task.opsGroup != group) return false
		if (cycleUuid && task.cycleUuid != cycleUuid) return false
		if (txt.length > 0
			&& !task.subject?.toLowerCase().includes(txt)
			&& !task.taskUuid?.includes(txt)
			&& !task.cycleUuid?.includes(txt)
		) return false
		return true
	})
	return tasksFiltered
}

/** mette in ordine un array di TASKs in base al due_time */
export function sortByDueTime(tasks: Task[]): Task[] {
	return tasks.sort((t1, t2) => {
		if (!t1.dueTime) return 1
		if (!t2.dueTime) return -1
		return t1.dueTime < t2.dueTime ? -1 : 1;
	})
}